/**
 * Build reveal context for the current page
 * Keep this dumb and expandable.
 */
export function createRevealContext() {
	const body = document.body

	return {
		// core nodes
		body,
		container:
			document.querySelector('[data-swup-container]') ||
			document.querySelector('main') ||
			body,

		// page metadata
		template: body.dataset.revealTemplate || null,

		// placeholders for future expansion
		entry: null, // 'direct' | 'swup' | 'history'
		skipElements: null, // for shared-element transitions
		prefersReducedMotion: window.matchMedia(
			'(prefers-reduced-motion: reduce)'
		).matches,
	}
}
